const getLogHandler = (log: (...args: any[]) => void, hideMessages: string[], stillLog?: boolean) => {
    return (...args: any[]) => {
        if (stillLog) {
            log('caught', args);
        }

        if (hideMessages.some((message) => args[0]?.includes?.(message))) {
            return;
        }

        log('from handler', ...args);

        log(...args);
    };
};

export const hideConsoleErrors = () => {
    console.warn = getLogHandler(console.warn, [
        'Use style.pointerEvents',
        '`useNativeDriver` is not supported because the native animated module is missing',
        'Chrome is moving towards a new experience that allows users to choose to browse without third-party cookies.',
        '"shadow*" style props are deprecated. Use "boxShadow".',
        'Bugsnag.getPlugin() was called before Bugsnag.start()',
    ]);
};
